import { Text, TextSize, TextTag } from '../text';
import { styled, css } from '../theme-provider';
import { ReactElement, ReactNode } from 'react';

export const CONFIGURABLE_TITLE_LAYOUT_AREA = 'SectionHeader';
export const SectionHeader = styled.div<{
  readonly useArea?: boolean;
  readonly useSubgrid?: boolean;
}>`
  display: grid;
  grid-template-columns: 100%;
  row-gap: 10px;
  grid-template-rows: ${({ useSubgrid }) => (useSubgrid ? 'subgrid' : 'auto')};

  ${({ useArea }) =>
    useArea &&
    css`
      grid-area: ${CONFIGURABLE_TITLE_LAYOUT_AREA};
      align-self: center;
      grid-template-columns: auto;
    `};

  @media print {
    page-break-after: avoid;
  }
`;
export const ReportDescription = styled(Text)`
  color: #9b9b9b;
`;
export const Title = styled(Text)`
  display: flex;
  align-content: center;
  column-gap: 16px;
`;

interface ReportingSectionHeaderProps {
  readonly useArea?: boolean;
  readonly useSubgrid?: boolean;
  readonly title?: ReactElement | ReactNode;
  readonly subSection?: boolean;
  readonly description?: ReactElement | ReactNode;
}

export function ReportingSectionHeader({
  useArea,
  useSubgrid,
  title,
  subSection,
  description,
}: ReportingSectionHeaderProps) {
  return (
    <SectionHeader useArea={useArea} useSubgrid={useSubgrid && useArea}>
      {title && (
        <Title
          size={subSection ? TextSize.s14 : TextSize.s16}
          tag={TextTag.div}
          medium
        >
          {title}
        </Title>
      )}
      {description && (
        <ReportDescription size={TextSize.s12} tag={TextTag.div}>
          {description}
        </ReportDescription>
      )}
    </SectionHeader>
  );
}
